import { em } from 'polished'
import styled from 'styled-components'

import { Row } from 'styles/components/layout'
import { CartItemTitle } from 'styles/components/typography'

export const RowStyled = styled(Row)`
  margin-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(30)};
  }
`

export const CostBlock = styled.div`
  text-align: right;
  line-height: 0;

  ${p => p.theme.mq.upMd} {
    text-align: left;
  }
`

export const CartItemTitleStyled = styled(CartItemTitle)`
  text-align: right;

  ${p => p.theme.mq.upMd} {
    text-align: left;
    font-size: ${p => p.theme.typography.fontSize};
    line-height: ${p => p.theme.typography.cartFontLh};
  }
`
